/**
 * Shape of the JSON Gemini emits per DATASHEET_SCHEMA on the backend. Fields
 * the AI couldn't find in the PDF are omitted, so every property is optional.
 */
export interface DatasheetSpec {
  name: string;
  value: string;
}

export interface DatasheetAiSummary {
  title?: string;
  model_numbers?: string[];
  manufacturer?: string;
  summary?: string;
  key_features?: string[];
  /**
   * Array of {name, value} pairs from the SPECIFICATIONS table. Previously
   * modeled as a Record<string, string> map, but Gemini's structured-output
   * mode does not reliably support free-form maps — the array form is the
   * portable representation.
   */
  specifications?: DatasheetSpec[];
  dimensions?: string;
  certifications?: string[];
  connectivity?: string[];
  power?: string;
  operating_conditions?: string;
  warranty?: string;
  in_the_box?: string[];
  revision?: string;
}

export function parseDatasheetSummary(raw: string | null | undefined): DatasheetAiSummary | null {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object") return parsed as DatasheetAiSummary;
    return null;
  } catch {
    return null;
  }
}
